// @ts-nocheck
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import {
    chain,
    LoadInventory as baseLoadInventory,
} from "@insite/client-framework/Store/Components/ProductSelector/Handlers/SetProduct";
import { createFromProduct } from "@store/Modules/client-framework/src/Common/ProductInfo";
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

export const LoadInventory = createChainHandler("LoadInventory", chain, async props => {
    // Only the "createFromProduct" function import has changed.
    const product = props.product;
    if (!product) {
        return;
    }
    props.productInfo = createFromProduct(product);

    let loadedInventory = false;

    props.dispatch(
        loadRealTimeInventory({
            productIds: [product.id],
            onComplete: realTimeInventoryProps => {
                if (realTimeInventoryProps.error) {
                    if (props.productInfo) {
                        props.productInfo.failedToLoadInventory = true;
                    }
                } else if (props.productInfo) {
                    props.productInfo.inventory = realTimeInventoryProps.apiResult?.realTimeInventoryResults?.find(
                        o => o.productId === product.id,
                    );
                }
                loadedInventory = true;
            },
        }),
    );

    await waitFor(() => loadedInventory);
});

replaceInChain(chain, baseLoadInventory, LoadInventory);
